import { SET_ERROR, DELETE_ERROR, SET_SUCCESS, DELETE_SUCCESS } from "../types";

export const setError = (error) => ({ error, type: SET_ERROR });
export const deleteError = () => ({ type: DELETE_ERROR });

export const setSuccess = (success) => ({ success, type: SET_SUCCESS });
export const deleteSuccess = () => ({ type: DELETE_SUCCESS });
